import $ from 'jquery';
import SliderRange from 'blocks/slider-range/slider-range';

export default class {
	constructor(options) {
		const defaults = {
			el: '#yotaTariffVoice',
			dom: {
				sliderRange: '.js-slider-range',
				price: '#yotaTariffVoicePrice',
				toggler: '#yotaTariffVoiceToggler',
				sms: '.js-tariff-set-sms',
				speed: {
					hour2: '.js-tariff-set-2hour',
					hour24: '.js-tariff-set-24hour'
				},
				input: {
					minutes: '#yotaTariffVoiceInputMinutes',
					price: '#yotaTariffVoiceInputPrice'
				}
			},
			classes: {
				minutes: 'b-tariff-mobile_minutes_max'
			}
		};

		this.options = $.extend(true, {}, defaults, options);
		this.$el = $(this.options.el);
		this.$window = $(window);
		this.activated = false;
		this.price = false;
		this.$sms = $(this.options.dom.sms);
		this.speed = {};
		this.speed.$hour2 = $(this.options.dom.speed.hour2);
		this.speed.$hour24 = $(this.options.dom.speed.hour24);
		return this;
	}

	getDom() {
		this.$sliderRange = this.$el.find(this.options.dom.sliderRange);
		this.$price = this.$el.find(this.options.dom.price);
		this.$toggler = this.$el.find(this.options.dom.toggler);
		this.input = {};
		this.input.$minutes = this.$el.find(this.options.dom.input.minutes);
		this.input.$price = this.$el.find(this.options.dom.input.price);
		return this;
	}

	onSlide(position, rate) {
		rate.action = rate.action || false;
		this.rate = rate;
		this.price = this.rate.price;
		this.setPrice(false, rate.price);
		this.input.$minutes.val(this.rate.minutes);
		this.input.$price.val(this.rate.price);
		this.$el.toggleClass(this.options.classes.minutes, this.data.rates.length - 1 == position);
		this.$el.data('params', [this.rate.ancor]);
		this.$window.trigger('yota.router.check');
	}


	setPrice(event, price) {
		const set = price || this.price;
		if (this.unlimitedSms()) {
			this.$price.text(parseInt(set) + parseInt(this.data.unlimitedSmsPrice) + parseInt(this.data.internet));
		} else {
			this.$price.text(parseInt(set) + parseInt(this.data.internet));
		}
	}

	unlimitedSms() {
		if (this.$toggler.prop('checked')) {
			return true;
		}
		return false;
	}

	activate() {
		const self = this;
		if (!self.activated && self.$el.data('activated') === true) {
			self.activated = true;
			setTimeout(function () {
				self.sliderRange.animate();
			}, 100);
		}
	}

	update() {
		const params = this.$el.data('params') || [];
		if (params.length) {
			this.data.baseRate = this.sliderRange.getRate(params[0], 'ancor').rate.price;
			this.sliderRange.update({base: this.data.baseRate});
		}
	}

	render() {
		if (this.$el.length) {
			if (yotaPortlets.tariffVoice) {
				this.data = yotaPortlets.tariffVoice;
				this.price = this.data.baseRate;
				this.getDom();
				this.$toggler.on('change', this.setPrice.bind(this));
				this.$sms.html(this.data.smsPrice);
				if (typeof this.data['2hour'] != 'undefined') {
					this.speed.$hour2.html(this.data['2hour']);
				}
				if (typeof this.data['24hour'] != 'undefined') {
					this.speed.$hour24.html(this.data['24hour']);
				}

				this.sliderRange = new SliderRange({
					el: this.$sliderRange,
					base: this.data.baseRate,
					rates: this.data.rates,
					callback: {
						update: this.onSlide.bind(this)
					}
				});

				const labels = [];
				$.each(this.data.rates, function (key, item) {
					labels.push({
						js: key,
						price: item.minutes
					});
				});

				this.sliderRange.buildLabels(labels);

				this.$el
					.on('yota.router.activate', this.activate.bind(this))
					.on('yota.router.update', this.update.bind(this))
					.trigger('yota.router.update');

				this.sliderRange.render();
				this.$el.data('params', [this.rate.ancor]);
				this.$window.trigger('yota.router.check');
				this.$el.trigger('yota.router.activate');


			} else {
				console.error('The tariffVoice portlet has no data, set data to "yotaPortlets.tariffVoice"');
			}
		}
		return this;
	}
}



// WEBPACK FOOTER //
// ./app/portlets/site/tariff-voice/tariff-voice.js